import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './languages/en.json';
import deTranslation from './languages/de.json';
import esTranslation from './languages/es.json';
import frTranslation from './languages/fr.json';
import ptBRTranslation from './languages/pt-BR.json';
import svTranslation from './languages/sv.json';
import swTZTranslation from './languages/sw-TZ.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
            },
            de: {
                translation: deTranslation
            },
            es: {
                translation: esTranslation
            },
            fr: {
                translation: frTranslation
            },
            ptBR: {
                translation: ptBRTranslation
            },
            sv: {
                translation: svTranslation
            },
            swTZ: {
                translation: swTZTranslation
            },
        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
